package crashreporting

object NoOpCrashReporter : CrashReporter {
    override fun capture(throwable: Throwable, extras: Map<String, String>) = Unit
    override fun identify(userId: String?) = Unit
    override fun setTag(key: String, value: String) = Unit
    override fun clearUser() = Unit
}
